var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStaciaFavicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 592,
    height: 399,
    viewBox: "0 0 592 399",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M471.788 155.352C462.671 155.352 454.643 161.516 452.173 170.464L417.324 296.089C414.853 304.947 406.942 311.111 397.885 311.201L98.3006 314.014C52.5998 314.822 14.1629 362.193 0.046875 398.821H486.875C496.227 398.821 504.373 392.357 506.667 383.111L523.959 312.877H524.664L541.398 252.578C554.896 203.95 520.106 155.352 471.788 155.352Z",
    fill: "#151F43"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M591.749 0.820312H104.98C95.6277 0.820312 87.4816 7.28411 85.1877 16.5309L67.8955 86.7649H67.1897L50.4563 147.064C36.9578 195.692 71.7481 244.29 120.066 244.29C129.183 244.29 137.211 238.125 139.682 229.178L174.531 103.553C177.001 94.695 184.912 88.5304 193.97 88.4407L493.554 85.6277C539.254 84.8197 577.838 37.4485 591.954 0.820313H591.719L591.749 0.820312Z",
    fill: "#151F43"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M348.928 174.995C361.913 174.852 373.555 162.649 377.581 156.219H245.601C237.518 156.219 230.602 161.849 229.085 169.593L228.735 171.336H228.53L215.02 240.38L214.378 245.01C214.378 245.01 213.568 250.925 217.063 250.925V250.982H362.962C358.935 244.524 345.865 233.722 332.88 233.579H257.068C246.09 233.579 246.798 227.864 246.798 227.864L257.068 184.11C258.907 176.795 259.521 175.024 267.224 174.995H348.928Z",
    fill: "#1C39BB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStaciaFavicon);
export default __webpack_public_path__ + "static/media/StaciaFavicon.4c3cc3b2f06d2d0f095c8df908d25153.svg";
export { ForwardRef as ReactComponent };